module.exports = __webpack_public_path__ + "img/largerRisk.636ca2cc.png";